const hy = {
  showMore: 'Show more',
  showLess: 'Show less',
};
export default hy;
